import React, { useState, useEffect } from "react";
import Sidebar from "../components/common/Sidebar";
import Header from "../components/common/Header";
import TimesIcon from "../asessts/Images/times_icon.svg";
import PluseIcon from "../asessts/Images/plus_icon.svg";
import emptyIllustration from "../asessts/Images/empty_illustration.jpg";
import Select from "react-select";
import Api from "./Api";
import Loading from "../components/loader/Loading";
const Services = () => {
  const [showServicePopup, setShowServicePopup] = useState(false);
  const [showInsurancePopup, setShowInsurancePopup] = useState(false);
  const [services, setServices] = useState([]);
  const [insurances, setInsurances] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreatingService, setIsCreatingService] = useState(false);

  const [newService, setNewService] = useState({
    category: "",
    name: "",
    description: "",
  });
  const [newInsurance, setNewInsurance] = useState({
    name: "",
  });

  const [errors, setErrors] = useState({
    service: {},
    insurance: {},
  });

  useEffect(() => {
    const fetchServiceData = async () => {
      try {
        const response = await Api.getServiceData();
        if (response.data.status) {
          const apiData = response.data.data;

          const transformedServices = [
            {
              id: 1,
              name: "Hospital",
              items:
                apiData?.hospClinic?.otherServices?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Service ID",
              nameLabel: "Service Name",
            },
            {
              id: 2,
              name: "Laboratory",
              items:
                apiData?.laboratory?.investigations?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Investigation ID",
              nameLabel: "Investigation Type",
            },
            {
              id: 3,
              name: "Fitness Center",
              items:
                apiData?.fitnessCenter?.categories?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Category ID",
              nameLabel: "Category",
            },
            {
              id: 4,
              name: "Insurances",
              items:
                apiData?.hospClinic?.insurances?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Insurance ID",
              nameLabel: "Insurance Name",
            },
            {
              id: 5,
              name: "Doctor Services",
              items:
                apiData?.doctorService?.doctorService?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Insurance Service ID",
              nameLabel: "Doctor Service Name",
            },
            {
              id: 6,
              name: "Lab Scientist",
              items:
                apiData?.labScientistService?.labScientistServices?.map(
                  (item) => ({
                    id: item.serviceId,
                    name: item.name,
                  })
                ) || [],
              idLabel: "Lab Scientist Service ID",
              nameLabel: "Lab Scientist Service Name",
            },
          ];

          setServices(transformedServices);
          setInsurances(
            apiData?.hospClinic?.insurances?.map((item) => ({
              id: item.serviceId,
              name: item.name,
            })) || []
          );
        }
      } catch (error) {
        console.error("Error fetching service data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchServiceData();
  }, []);
  if (isLoading) {
    return (
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header title={"Services"} />
          <div className="dashboard-loading">
            <Loading />
          </div>
        </div>
      </div>
    );
  }

  const validateServiceForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!newService.category.trim()) {
      newErrors.category = "Please select a service category";
      isValid = false;
    }

    if (!newService.name.trim()) {
      newErrors.name = "Service name is required";
      isValid = false;
    } else if (newService.name.length < 3) {
      newErrors.name = "Service name must be at least 3 characters";
      isValid = false;
    } else if (/^\d+$/.test(newService.name)) {
      newErrors.name = "Service name cannot be only numbers";
      isValid = false;
    }

    setErrors((prev) => ({ ...prev, service: newErrors }));
    return isValid;
  };

  const validateInsuranceForm = () => {
    const newErrors = {};
    let isValid = true;

    if (!newInsurance.name.trim()) {
      newErrors.name = "Insurance name is required";
      isValid = false;
    } else if (newInsurance.name.length < 3) {
      newErrors.name = "Insurance name must be at least 3 characters";
      isValid = false;
    } else if (/^\d+$/.test(newInsurance.name)) {
      newErrors.name = "Insurance name cannot be only numbers";
      isValid = false;
    } else if (
      insurances.some(
        (ins) => ins.name.toLowerCase() === newInsurance.name.toLowerCase()
      )
    ) {
      newErrors.name = "Insurance with this name already exists";
      isValid = false;
    }

    setErrors((prev) => ({ ...prev, insurance: newErrors }));
    return isValid;
  };

  const toggleServicePopup = () => {
    setShowServicePopup(!showServicePopup);
    setErrors((prev) => ({ ...prev, service: {} }));
    setNewService({
      category: "",
      name: "",
      description: "",
    });
    document.body.style.overflow = showServicePopup ? "auto" : "hidden";
  };

  const toggleInsurancePopup = () => {
    setShowInsurancePopup(!showInsurancePopup);
    setErrors((prev) => ({ ...prev, insurance: {} }));
    setNewInsurance({
      name: "",
    });
    document.body.style.overflow = showInsurancePopup ? "auto" : "hidden";
  };

  const handleServiceInputChange = (e) => {
    const { name, value } = e.target;
    setNewService({
      ...newService,
      [name]: value,
    });
    if (errors.service[name]) {
      setErrors((prev) => ({
        ...prev,
        service: {
          ...prev.service,
          [name]: "",
        },
      }));
    }
  };

  const handleInsuranceInputChange = (e) => {
    const { name, value } = e.target;
    setNewInsurance({
      ...newInsurance,
      [name]: value,
    });
    if (errors.insurance[name]) {
      setErrors((prev) => ({
        ...prev,
        insurance: {
          ...prev.insurance,
          [name]: "",
        },
      }));
    }
  };

  const addNewServiceData = async () => {
    if (!validateServiceForm()) return;

    try {
      setIsCreatingService(true);
      const payload = {
        serviceCategory: newService.category,
        serviceName: newService.name,
        text: newService.description,
      };

      const token = localStorage.getItem("token");
      const response = await Api.addNewService(payload, token);

      if (response.status) {
        const refreshed = await Api.getServiceData();
        if (refreshed.data.status) {
          const apiData = refreshed.data.data;
          const transformedServices = [
            {
              id: 1,
              name: "Hospital",
              items:
                apiData?.hospClinic?.otherServices?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Service ID",
              nameLabel: "Service Name",
            },
            {
              id: 2,
              name: "Laboratory",
              items:
                apiData?.laboratory?.investigations?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Investigation ID",
              nameLabel: "Investigation Type",
            },
            {
              id: 3,
              name: "Fitness Center",
              items:
                apiData?.fitnessCenter?.categories?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Category ID",
              nameLabel: "Category",
            },
            {
              id: 4,
              name: "Insurances",
              items:
                apiData?.hospClinic?.insurances?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Insurance ID",
              nameLabel: "Insurance Name",
            },
            {
              id: 5,
              name: "Doctor Services",
              items:
                apiData?.doctorService?.doctorService?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Insurance Service ID",
              nameLabel: "Doctor Service Name",
            },
            {
              id: 6,
              name: "Lab Scientist",
              items:
                apiData?.labScientistService?.labScientistServices?.map(
                  (item) => ({
                    id: item.serviceId,
                    name: item.name,
                  })
                ) || [],
              idLabel: "Lab Scientist Service ID",
              nameLabel: "Lab Scientist Service Name",
            },
          ];

          setServices(transformedServices);
        }

        setNewService({
          category: "",
          name: "",
          description: "",
        });
        toggleServicePopup();
      } else {
        alert("Failed to add service");
      }
    } catch (error) {
      console.error("Error adding new service:", error);
    } finally {
      setIsCreatingService(false);
    }
  };
  const addNewInsurance = async () => {
    if (!validateInsuranceForm()) return;

    try {
      setIsCreatingService(true);

      const payload = {
        serviceCategory: "Insurance",
        serviceName: newInsurance.name,
        text: "",
      };

      const token = localStorage.getItem("token");
      const response = await Api.addNewService(payload, token);

      if (response.status) {
        const refreshed = await Api.getServiceData();
        if (refreshed.data.status) {
          const apiData = refreshed.data.data;
          const transformedServices = [
            {
              id: 1,
              name: "Hospital",
              items:
                apiData?.hospClinic?.otherServices?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Service ID",
              nameLabel: "Service Name",
            },
            {
              id: 2,
              name: "Laboratory",
              items:
                apiData?.laboratory?.investigations?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Investigation ID",
              nameLabel: "Investigation Type",
            },
            {
              id: 3,
              name: "Fitness Center",
              items:
                apiData?.fitnessCenter?.categories?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Category ID",
              nameLabel: "Category",
            },
            {
              id: 4,
              name: "Insurances",
              items:
                apiData?.hospClinic?.insurances?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Insurance ID",
              nameLabel: "Insurance Name",
            },
            {
              id: 5,
              name: "Doctor Services",
              items:
                apiData?.doctorService?.doctorService?.map((item) => ({
                  id: item.serviceId,
                  name: item.name,
                })) || [],
              idLabel: "Insurance Service ID",
              nameLabel: "Doctor Service Name",
            },
            {
              id: 6,
              name: "Lab Scientist",
              items:
                apiData?.labScientistService?.labScientistServices?.map(
                  (item) => ({
                    id: item.serviceId,
                    name: item.name,
                  })
                ) || [],
              idLabel: "Lab Scientist Service ID",
              nameLabel: "Lab Scientist Service Name",
            },
          ];

          setServices(transformedServices);
          setInsurances(
            apiData?.hospClinic?.insurances?.map((item) => ({
              id: item.serviceId,
              name: item.name,
            })) || []
          );

          setNewInsurance({ name: "" });
          toggleInsurancePopup();
        }
      } else {
        alert("Failed to add insurance");
      }
    } catch (error) {
      console.error("Error adding insurance:", error);
    } finally {
      setIsCreatingService(false);
    }
  };

  const categoryOptions = [
    { value: "", label: "Select Category" },
    { value: "hospital", label: "Hospital" },
    { value: "laboratory", label: "Laboratory" },
    { value: "fitnesscenter", label: "Fitness Center" },
    { value: "doctor", label: "Doctor Services" },
    { value: "medicallabscientist", label: "Lab Scientist" },
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#F9FAFB",
      borderColor: "#E5E7EB",
      borderRadius: "0.5rem",
      padding: "2px 4px",
      width: "474px",
      height: "52px",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#4b5563",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor:
        state.isFocused || state.isSelected ? "#D58DE8" : "white",
      color: state.isFocused || state.isSelected ? "white" : "#4B5563",
      fontSize: "12px",
      padding: 5,
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#4B5563",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#111827",
      fontSize: "12px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#9CA3AF",
      fontSize: "12px",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "0.5rem",
      //zIndex: 20
    }),
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />

      <div className="main-dashboard subadmin-dashboard">
        <Header title={"Services"} />

        <div className="services-main">
          <div className="service-btn">
            <button className="service-button" onClick={toggleServicePopup}>
              <img src={PluseIcon} alt="" /> Add Service
            </button>
            <button onClick={toggleInsurancePopup}>
              <img src={PluseIcon} alt="" /> Add insurance
            </button>
          </div>

          <div className="service-type-main">
            {services.map((category) => (
              <div className="service" key={category.id}>
                <div className="head">
                  <h2>{category.name}</h2>
                </div>
                <div className="id">
                  <span>{category.idLabel}</span>
                  <span>{category.nameLabel}</span>
                </div>
                {!category.items || category.items.length === 0 ? (
                  <div style={{ textAlign: "center", padding: "24px 12px" }}>
                    <img
                      src={emptyIllustration}
                      alt={`No ${category.name} found`}
                      style={{ maxWidth: "260px", width: "100%", height: "auto" }}
                    />
                    <p
                      style={{
                        marginTop: "14px",
                        fontSize: "14px",
                        color: "#666",
                      }}
                    >
                      No data found
                    </p>
                  </div>
                ) : (
                  <ul>
                    {category.items.map((item) => (
                      <li key={item.id}>
                        {item.id} <span>{item.name}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add Service Popup */}
      <div
        className={`add-service-main ${
          showServicePopup ? "service-active" : ""
        }`}
      >
        <div className="close-btn">
          <button onClick={toggleServicePopup}>
            <img src={TimesIcon} alt="" />
          </button>
        </div>
        <div className="heading">
          <h4>Add a new Service</h4>
          <p>Easily create a new service and share it with the facilities.</p>
        </div>

        <div className="input-group">
          <div className={`${errors.service.category ? "has-error" : ""}`}>
            <label className="service-label">Service Category</label>
            <Select
              options={categoryOptions}
              styles={customStyles}
              value={categoryOptions.find(
                (opt) => opt.value === newService.category
              )}
              onChange={(selectedOption) => {
                setNewService((prev) => ({
                  ...prev,
                  category: selectedOption.value,
                }));
              }}
              isSearchable={false}
            />
            {errors.service.category && (
              <span className="select-error">{errors.service.category}</span>
            )}
          </div>
        </div>

        <div className="input-group">
          <div className="input-field">
            <label>Service Name</label>
            <input
              type="text"
              className={`form-control ${
                errors.service.name ? "is-invalid" : ""
              }`}
              placeholder="24/7 Availability"
              name="name"
              value={newService.name}
              onChange={handleServiceInputChange}
            />
            {errors.service.name && (
              <div className="invalid-feedback">{errors.service.name}</div>
            )}
          </div>
        </div>
        <button
          className="create-btn"
          onClick={addNewServiceData}
          style={{ marginTop: "15px" }}
          disabled={isCreatingService}
        >
          {isCreatingService ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Create Service"
          )}
        </button>
      </div>

      {/* Add Insurance Popup */}
      <div
        className={`add-insurance-main ${
          showInsurancePopup ? "service-active" : ""
        }`}
      >
        <div className="close-btn">
          <button onClick={toggleInsurancePopup}>
            <img src={TimesIcon} alt="" />
          </button>
        </div>
        <div className="heading">
          <h3>Add Insurance</h3>
          <p>Easily create a new insurance and share it with the facilities.</p>
        </div>
        <div className="input-group">
          <div className="input-field">
            <label>Insurance Name</label>
            <input
              type="text"
              className={`form-control ${
                errors.insurance.name ? "is-invalid" : ""
              }`}
              placeholder="Enter insurance name"
              name="name"
              value={newInsurance.name}
              onChange={handleInsuranceInputChange}
            />
            {errors.insurance.name && (
              <div className="invalid-feedback">{errors.insurance.name}</div>
            )}
          </div>
        </div>

        <button
          className="create-btn"
          onClick={addNewInsurance}
          style={{ marginTop: "15px" }}
          disabled={isCreatingService}
        >
          {isCreatingService ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            "Create Insurance"
          )}
        </button>
      </div>

      {/* Overlay */}
      <div
        className={`overlay ${
          showServicePopup || showInsurancePopup ? "active" : ""
        }`}
      ></div>
    </div>
  );
};

export default Services;
